module.exports = __webpack_public_path__ + "img/tel_2.c5f8d8e0.png";